/**
 * Engraving Mask feature: merge 1, 2, or 3 images into a shape (circle, oval, heart, rectangle L/M SVG paths)
 * with configurable direction (vertical/horizontal) and spacing.
 */

export { default as EngravingMaskEditor } from './EngravingMaskEditor.vue'
export { default as EngravingMaskToolbar } from './EngravingMaskToolbar.vue'
export {
  NUM_PARTS_OPTIONS,
  DIRECTION_OPTIONS,
  SHAPE_OPTIONS,
  SIZE_OPTIONS,
  SPACING_OPTIONS,
  DEFAULT_OUTPUT_SIZE,
} from './constants'
